import { lazyLoad } from 'site-modules/shared/components/lazy-load/lazy-load';
import { ThankYouViewDecorator } from 'site-modules/shared/components/lead-form/unified-lead-form/views/thank-you-view-decorator';

export const SetYourPriceThankYouViewAsync = ThankYouViewDecorator(
  lazyLoad({
    loader: () => import(/* webpackChunkName: "set-your-price-thank-you-view" */ './set-your-price-thank-you-view'),
    componentName: 'SetYourPriceThankYouView',
  })
);
